import { Component } from '@angular/core';

@Component({
    selector: 'kui-header-nav-buttons',
    templateUrl: './header-nav-buttons.component.html',
    standalone: false
})
export class KuiHeaderNavButtonsComponent { }
